import { useQuerySubscription } from "react-datocms"
import { getAllRecords, getSubscription, queries, request } from "@data/datocms"
import { datoModels } from "@data/static"
import { loadOptionsData } from "@data/options"

import ProductEdit from "@components/product/ProductEdit/ProductEdit"
import Layout from "@components/structure/Layout/layout"
import Seo from "@components/structure/Seo/Seo"

export async function getStaticPaths() {
  const { records } = await getAllRecords(datoModels.PRODUCT_EDIT, null, null, true)
  return {
    paths: records.map((productEdit) => `/products/${productEdit.slug}`),
    fallback: false,
  }
}

export async function getStaticProps({ params }) {
  const data = await request({ query: `{ productEdit(filter: {slug: {eq: "${params.slug}"}}) { id } }` })

  const graphqlRequest = {
    query: `
      query PartyEditPageBySlug($slug: String) {
        ${queries.seo}
        productEdit(filter: {slug: {eq: $slug}}) {
          ${queries.innerProductEdit}
        }
        products: allProducts(${
          params.slug !== "just-in" ? "filter: {edit: {eq: " + data.productEdit.id + "}}," : ""
        }, orderBy: createdAt_DESC, first: ${params.slug === "just-in" ? "20" : "100"}) {
          ${queries.product.query}
        }
      }
    `,
    variables: {
      slug: params.slug,
      edit: data.productEdit.id,
    },
  }

  const subscription = await getSubscription(graphqlRequest)
  const options = await loadOptionsData()


  return {
    props: {
      subscription,
      options
    },
  }
}

export default function partyServicePage({ subscription, options }) {
  const {
    data: { seo, productEdit, products },
  } = useQuerySubscription(subscription)

  return (
    <Layout options={options}>
      <Seo global={seo} meta={productEdit.seo} />
      <ProductEdit
        title={productEdit.title}
        description={productEdit.description}
        featuredImage={productEdit.featuredImage}
        formatTitle={productEdit.formatTitle}
        products={products}
      />
    </Layout>
  )
}
